export enum Cookies {
  AUTHORIZATION = "authorization",
}
